<template>
    <div
        style="margin: 1em;"
      id="carouselExampleIndicators"
      class="carousel slide"
      data-bs-ride="carousel"
    >
      <div class="carousel-indicators">
        <button
          v-for="(image, index) in images1"
          :key="index"
          type="button"
          :data-bs-target="'#carouselExampleIndicators'"
          :data-bs-slide-to="index"
          :class="{ 'active': index === 0 }"
          :aria-current="index === 0 ? 'true' : null"
          :aria-label="'Slide ' + (index + 1)"
        ></button>
      </div>
      <div class="carousel-inner">
        <div
          v-for="(image, index) in images1"
          :key="index"
          :class="{ 'carousel-item': true, 'active': index === 0 }"
        >
          <img
            :src="image"
            class="d-block w-100 img-fluid"
            style="border-radius: 18px"
            alt="carousel-image"
          />
        </div>
      </div>
      <button
        class="carousel-control-prev visually-hidden"
        type="button"
        data-bs-target="#carouselExampleIndicators"
        data-bs-slide="prev"
      >
        <span class="carousel-control-prev-icon" aria-hidden="true"></span>
        <span class="visually-hidden">Previous</span>
      </button>
      <button
        class="carousel-control-next visually-hidden"
        type="button"
        data-bs-target="#carouselExampleIndicators"
        data-bs-slide="next"
      >
        <span class="carousel-control-next-icon" aria-hidden="true"></span>
        <span class="visually-hidden">Next</span>
      </button>
    </div>
  </template>
  
  <script>
  export default {
    props: {
      images1: {
        type: Array,
        required: true
      }
    },
    mounted() {
        console.log('here')
        console.log(this.images1)
    }
  };
  </script>
  
  <style scoped>
  /* Add your carousel styles here */
  </style>
  